import { ModalDialog, ModalService } from './modal.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';



@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [DialogModule, NgClass, NgIf, TranslateModule, ButtonModule]
})
export class ModalComponent implements OnInit {

  public modalDialog: ModalDialog;

  public visible: boolean = false;

  constructor(public modalService: ModalService, private cdr: ChangeDetectorRef) { }

  public ngOnInit(): void {
    this.modalService.dialogSubject.subscribe((modalDialog) => {
      const actualDialog = this.modalDialog;
      this.modalDialog = modalDialog;
      if (!modalDialog) {
        this.modalDialog = null;
        this.hideDialog();
      } else {
        this.modalDialog = modalDialog;
        this.showDialog();
        if (actualDialog) {
          this.cdr.detectChanges();
        }
      }
    });
  }

  public okClicked(): void {
    this.hideDialog();
    this.modalDialog.onOkSubject.next(null);
  }

  public cancelClicked(): void {
    this.hideDialog();
    this.modalDialog.onCancelSubject.next(null);
  }

  public onClose(eventArgs): void {
    if (eventArgs.isInteracted) {
      this.modalDialog.onCancelSubject.next(null);
    }
  }

  private hideDialog(): void {
    this.visible = false;
  }

  private showDialog(): void {
    this.visible = true;
  }
}
